import { HexColorCode, ImageUrlMap } from './common';
import { ISODateTime } from '../../admin/types/date';
import { Coach } from './coach';
import moment from 'moment-timezone';
import { SheLocation } from './location';

export type EventId = number;

export enum EventStatus {
    ACTIVE = 'active',
    LINK_ONLY = 'link_only',
    HIDDEN = 'hidden',
}

export enum EventChargeScope {
    NON_MEMBERS = 'non_members',
    ALL_USERS = 'all_users',
}

export type EventDetails = {
    id: EventId;
    title: string;
    sub_title: string;
    location: SheLocation;
    key_color: HexColorCode;
    highlight: string;
    introduction: string;
    target_description: string;
    cover_photo_url: ImageUrlMap;
    thumbnail_photo_url: ImageUrlMap;
    price: number;
    price_with_tax: number;
    note: string;
    capacity: number;
    status: EventStatus;
    charge_scope: EventChargeScope;
    active_reservation_count: number;
    coaches: Coach[];
    starts_at: ISODateTime;
    ends_at: ISODateTime;
    full: boolean;
};

export class EventDetailsSorters {
    static byEventStartAsc() {
        return (x: EventDetails, y: EventDetails) => {
            const xStart = moment(x.starts_at);
            const yStart = moment(y.starts_at);
            return xStart.diff(yStart);
        };
    }
}
